import { WEBSITE_URL } from '@/config';
import * as React from 'react';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';

export const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="main-footer">
      <div className="copyrights">
        <p>
          © 2024, <span className="bold">Petsked</span> {t('All rights reserved.')}
        </p>
        <div className="privacy">
          <span>
            <a href={`${WEBSITE_URL}/terms-and-condition`} target="_blank" rel="noreferrer">
              {t('Terms')}
            </a>
          </span>
          <span className='seperator'></span>
          <span>
            <a href={`${WEBSITE_URL}/privacy-policy`} target="_blank" rel="noreferrer">
              {t('Privacy Policy')}
            </a>
          </span>
        </div>
      </div>
    </footer>
  );
};

export const LandingPageFooter = () => {
  const { t } = useTranslation();
  return (
    <>
      {isMobile ? (
        <footer className="mobile-footer-landing">
          <div className="copyrights">
            <div className="landing-div">
              <span className="landing-privacy">
                {t('By clicking on “Try Petsked”, you agree to our')}{' '}
                <a href={`${WEBSITE_URL}/terms-and-condition`} target="_blank" rel="noreferrer">
                  {t('terms')}
                </a>{' '}
                {t('& acknowledge our')}{' '}
                <a href={`${WEBSITE_URL}/privacy-policy`} target="_blank" rel="noreferrer">
                  {t('privacy policy')}
                </a>{' '}
              </span>
            </div>
            <p>
              © 2024, <span className="bold">Petsked</span> {t('All rights reserved.')}
            </p>
          </div>
        </footer>
      ) : (
        <footer className="main-footer">
          <div className="copyrights">
            <p>
              © 2024, <span className="bold">Petsked</span> {t('All rights reserved.')}
            </p>
            <div>
              <span className="landing-privacy">
              {t('By clicking on “Try Petsked”, you agree to our')}{' '}
                <a href={`${WEBSITE_URL}/terms-and-condition`} target="_blank" rel="noreferrer">
                  {t('terms')}
                </a>{' '}
                {t('& acknowledge our')}{' '}
                <a href={`${WEBSITE_URL}/privacy-policy`} target="_blank" rel="noreferrer">
                  {t('privacy policy')}
                </a>{' '}
              </span>
            </div>
          </div>
        </footer>
      )}
    </>
  );
};
